import Image from "next/image";
import React from "react";
import { LinkedIn } from "@/assets/icons";
import YouTube from "@/assets/icons/Youtube";
import { Fundview } from "@/assets/images";

const socialMedia = [
  {
    icon: YouTube,
    label: "YouTube",
    link: "https://www.youtube.com/@fundview_CREdealflow",
  },
  {
    icon: LinkedIn,
    label: "LinkedIn",
    link: "https://www.linkedin.com/company/fundview",
  },
];

const options = [
  {
    label: "Home",
    link: "/",
    target: "_self",
  },
  {
    label: "Google API Disclosure",
    link: "https://www.fundview.com/blog/google-api-disclosure",
    target: "_blank",
  },
  {
    label: "Privacy",
    link: "https://www.fundview.com/policy",
    target: "_blank",
  },
  {
    label: "Contact",
    link: "mailto:support@fundview.com",
    target: "_blank",
  },
];

function Footer() {
  return (
    <section className="bg-gray-50 py-10 sm:pt-16 lg:pt-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-x-12 gap-y-16 md:col-span-3 lg:grid-cols-6">
          <div className="col-span-2 md:col-span-3 lg:col-span-2 lg:pr-8">
            <Image className="h-9 w-auto" src={Fundview} alt="Logo" />

            <p className="mt-7 text-base leading-relaxed text-gray-600">
              Fundview is a powerful CRM for brokers, streamlining client management, deal tracking, and workflows.
              Boost productivity and drive growth with our intuitive solution—your partner in brokerage success.
            </p>

            <ul className="mt-9 flex items-center space-x-3">
              {socialMedia.map(item => (
                <li key={item.label}>
                  <a href={item.link} title="" className="flex size-7 items-center justify-center">
                    <item.icon className="h-9 w-auto transition-all duration-200 hover:text-blue-800" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-gray-400">Company</p>

            <ul className="mt-6 space-y-4">
              {options.map(item => (
                <li key={item.label}>
                  <a
                    href={item.link}
                    title={item.label}
                    target={item.target}
                    className="flex text-base text-black transition-all duration-200 hover:text-blue-600 focus:text-blue-600"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
